var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M379.115 302.85a8.327 8.327 0 0 1 16.652 0v84.592a8.33 8.33 0 0 1-8.326 8.326h-53.783a8.327 8.327 0 0 1 0-16.654h45.457zm8.326-33.76c65.36 0 118.346 52.99 118.346 118.352 0 65.359-52.985 118.346-118.346 118.346s-118.346-52.986-118.346-118.346c.001-65.362 52.985-118.352 118.346-118.352zM222.715 6l72.292 41.734L78.503 172.732v59.518l71.554 41.309v-59.512L366.561 89.043 439.221 131v131.734c-15.943-6.627-33.432-10.295-51.779-10.295-74.559 0-134.998 60.445-134.998 135.002 0 31.904 11.072 61.219 29.575 84.318L222.715 506 6.213 381.002V131z",
    clipRule: "evenodd",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingorder);
export default __webpack_public_path__ + "static/media/pending order.df2edfee9e4060d12756d8d029f0b6e6.svg";
export { ForwardRef as ReactComponent };